import React from "react"
import * as styles from "./Styles/Summary.module.scss"
import "../../../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const SummaryImages = (props) => {
  const couple = props.images.length == 2
  const multiple = props.images.length > 2
  return (
    <div className="l-flex">
      {props.images.length > 0 && (
        <div
          className={cn(
            "images",
            "first",
            couple || multiple ? "multiple--first" : "single"
          )}
        >
          <img src={props.images[0]} />
        </div>
      )}
      {couple && (
        <div className={cn("images", "couple")}>
          <img src={props.images[1]} />
        </div>
      )}
      {multiple && (
        <div className={cn("images", "multiple")}>
          {props.images.slice(1).map((url) => (
            <img key={url} src={url} />
          ))}
        </div>
      )}
    </div>
  )
}

const TakeawaySummary = (props) => {
  return (
    <a href={props.place.path}>
      <div className={styles.takeaway}>
        {props.place.images && <SummaryImages images={props.place.images} />}
        <div className={styles.title}>{props.place.name}</div>
        <div className={styles.address}>{props.place.city}</div>
      </div>
    </a>
  )
}

export default TakeawaySummary
